module.exports = __webpack_public_path__ + "img/broadcast-test-icon1.1ee3fdf6.png";